import { CommonValidationMessages } from "../../Messages";
export const ValidationRulesForBasicInformation = [
    {
        entryTypeId: 1,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
            // eventNotificationPeriod: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "notification period"),
            //     },
            //     {
            //         type: "number",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "only numbers in notification period"),
            //     },
            // ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
        }
    },
    {
        entryTypeId: 2,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
            // eventNotificationPeriod: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "notification period"),
            //     },
            //     {
            //         type: "number",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "only numbers in notification period"),
            //     },
            // ],
        }
    },
    {
        entryTypeId: 3,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            // eventNotificationPeriod: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "notification period"),
            //     },
            //     {
            //         type: "number",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "only numbers in notification period"),
            //     },
            // ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
        }
    },
    {
        entryTypeId: 4,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            // eventNotificationPeriod: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "notification period"),
            //     },
            //     {
            //         type: "number",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "only numbers in notification period"),
            //     },
            // ],
        }
    },
    {
        entryTypeId: 5,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            // eventNotificationPeriod: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "notification period"),
            //     },
            //     {
            //         type: "number",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "only numbers in notification period"),
            //     },
            // ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
            // eventFormStartDate: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "start date"),
            //     }
            // ],
            // eventFormEndDate: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "end date"),
            //     }
            // ],
        }
    },
    {
        entryTypeId: 6,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            // eventNotificationPeriod: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "notification period"),
            //     },
            //     {
            //         type: "number",
            //         message: CommonValidationMessages.FieldRequired.replace("{0}", "only numbers in notification period"),
            //     },
            // ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
        }
    },
    {
        entryTypeId: 8,
        validationRules: {
            eventName: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            // selectedTopicIds: [
            //     {
            //         type: "require",
            //         message: CommonValidationMessages.SelectRequired.replace("{0}", "entry topic"),
            //     }
            // ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
            eventFormStartDate: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "start date"),
                }
            ],
            eventFormEndDate: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "end date"),
                }
            ],
        }
    },
    {
        entryTypeId: 9,
        validationRules: {
            eventName:  [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
        }
    },
      {
        entryTypeId: 10,
        validationRules: {
            eventName:  [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "event name"),
                },
            ],
            eventTypeId: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry type"),
                }
            ],
            eventAbout: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace("{0}", "description about entry"),
                }
            ],
            eventImage: [
                {
                    type: "require",
                    message: CommonValidationMessages.SelectRequired.replace("{0}", "entry image"),
                }
            ],
        }
    },
];

export function RemoveValidation(validationRulesArr, typeId, ruleToRemove) {
    if (typeId > 0) {
        const valObj = validationRulesArr.find(x => x.entryTypeId === typeId).validationRules;
        let valRuleObj = { ...valObj };
        delete valRuleObj[ruleToRemove];
        validationRulesArr.find(x => x.entryTypeId === typeId).validationRules = valRuleObj;
    }
    return validationRulesArr;
}

export function AddValidation(validationRulesArr, typeId, addThisValidations) {
    if (typeId > 0) {
        addThisValidations.forEach((v, i) => {
            const valObj = validationRulesArr.find(x => x.entryTypeId === typeId).validationRules;
            let valRuleObj = { ...valObj };
            let arrayToAdd = [];
            v.types.forEach((t, n) => {
                let obj = validationObjectArray.find(x => x.type === t);
                obj.message = CommonValidationMessages.FieldRequired.replace("{0}", v.text);
                arrayToAdd.push(obj);
            });
            valRuleObj[v.for] = arrayToAdd;
            validationRulesArr.find(x => x.entryTypeId === typeId).validationRules = valRuleObj;
        });
    }
    return validationRulesArr;
}

export const validationObjectArray = [
    {
        type: "require",
        message: 'Please enter {0}',
    },
    {
        type: "number",
        message: 'Please enter {0}',
    },
    {
        type: "maxLength",
        message: 'Please enter {0}',
    },
    {
        type: "minLength",
        message: 'Please enter {0}',
    }
]
